module.exports = __webpack_public_path__ + "static/media/(LH)_MG_5244_-_Pro-Natura_-_Moda_Masculina_-_Moda_Masculina_Infantil_-_Moda_Familia.9828cfaf.jpg";